import React from 'react';

import { withStyles } from '@material-ui/core/styles';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';

import clsx from 'clsx';

import Button from './button';
import { expandStyles } from './styles';

export function ExpandButton(props) {
  const {
    open = true,
    className,
    expandDirection = 'down',
    classes,
    openCTA = 'Expand',
    closeCTA = 'Collapse',
    onClick,
    ...other
  } = props;

  const { pointUp, pointDown, pointLeft, pointRight, arrowIcon: arrowIconStyle, ...classesRest } = classes;

  const ArrowIcon = (
    <ArrowDropDownIcon data-testid='drop-down-icon' className={arrowIconStyle} viewBox='6.75 6.5 11 11' />
  );
  const [left, right, up, down] = ['left', 'right', 'up', 'down'];

  const customEndIcon =
    expandDirection === up ||
    expandDirection === down ||
    (open && expandDirection) === left ||
    (!open && expandDirection) === right
      ? ArrowIcon
      : null;

  const customStartIcon = (open && expandDirection === right) || (!open && expandDirection === left) ? ArrowIcon : null;

  return (
    <Button
      className={clsx(className, {
        [classes.pointRight]: (open && expandDirection === left) || (!open && expandDirection === right),
        [classes.pointLeft]: (open && expandDirection === right) || (!open && expandDirection === left),
        [classes.pointUp]: (open && expandDirection === down) || (!open && expandDirection === up),
        [classes.pointDown]: (open && expandDirection === up) || (!open && expandDirection === down),
      })}
      onClick={onClick}
      customStartIcon={customStartIcon}
      customEndIcon={customEndIcon}
      variant={null}
      classes={classesRest}
      {...other}
    >
      {open ? closeCTA : openCTA}
    </Button>
  );
}

export default withStyles(expandStyles)(ExpandButton);
